<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <div class="brand-mark">
        <img src="assets/images/logo_indi.jpg" alt="Indi" class="logo">
      </div>
      <h1>Indi Web</h1>
    </div>

    <div class="login-form">
      <p>Ingresa de forma segura con tu número de celular para continuar.</p>

      @if (!msalConfigured) {
        <div class="error-message">
          El inicio de sesión no está disponible por el momento. Inténtalo más tarde.
        </div>
      }

      @if (authError()) {
        <div class="error-message">
          {{ authError() }}
        </div>
      }

      <button type="button" (click)="onLogin()" [disabled]="loading() || !msalConfigured" class="btn-submit">
        {{ loading() ? 'Procesando...' : 'Continuar' }}
      </button>
    </div>

      <div class="login-footer">
        <p>Usa tu número registrado</p>
      </div>
    </div>
  </div>
